var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _ellipse, _circle2, _circle3, _circle4, _circle5, _circle6, _rect2, _rect3, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle7, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 407,
    height: 190,
    viewBox: "0 0 407 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.9025,
    y: 58.5974,
    width: 63.178,
    height: 106.5,
    rx: 8.72458,
    fill: "#E6EAF3",
    stroke: "#3361CF",
    strokeWidth: 1.80508
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2197 75.7056C39.2197 75.0632 40.0279 74.5424 41.0248 74.5424H83.1435C84.1404 74.5424 84.9485 75.0632 84.9485 75.7056C84.9485 76.3481 84.1404 76.8689 83.1435 76.8689H41.0248C40.0279 76.8689 39.2197 76.3481 39.2197 75.7056Z",
    fill: "url(#paint0_linear_1985_627)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2197 81.1343C39.2197 80.4918 40.0279 79.971 41.0248 79.971H71.1096C72.1065 79.971 72.9146 80.4918 72.9146 81.1343C72.9146 81.7767 72.1065 82.2975 71.1096 82.2975H41.0248C40.0279 82.2975 39.2197 81.7767 39.2197 81.1343Z",
    fill: "url(#paint1_linear_1985_627)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2197 86.5629C39.2197 85.9204 40.0279 85.3996 41.0248 85.3996H65.0926C66.0895 85.3996 66.8977 85.9204 66.8977 86.5629C66.8977 87.2053 66.0895 87.7262 65.0926 87.7262H41.0248C40.0279 87.7262 39.2197 87.2053 39.2197 86.5629Z",
    fill: "url(#paint2_linear_1985_627)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2197 91.9915C39.2197 91.3491 40.0279 90.8282 41.0248 90.8282H74.7197C75.7166 90.8282 76.5248 91.3491 76.5248 91.9915C76.5248 92.634 75.7166 93.1548 74.7197 93.1548H41.0248C40.0279 93.1548 39.2197 92.634 39.2197 91.9915Z",
    fill: "url(#paint3_linear_1985_627)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2197 97.4201C39.2197 96.7777 40.0279 96.2569 41.0248 96.2569H67.4994C68.4963 96.2569 69.3045 96.7777 69.3045 97.4201C69.3045 98.0626 68.4963 98.5834 67.4994 98.5834H41.0248C40.0279 98.5834 39.2197 98.0626 39.2197 97.4201Z",
    fill: "url(#paint4_linear_1985_627)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2197 102.849C39.2197 102.206 40.0279 101.685 41.0248 101.685H60.279C61.276 101.685 62.0841 102.206 62.0841 102.849C62.0841 103.491 61.276 104.012 60.279 104.012H41.0248C40.0279 104.012 39.2197 103.491 39.2197 102.849Z",
    fill: "url(#paint5_linear_1985_627)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2197 108.277C39.2197 107.635 40.0279 107.114 41.0248 107.114H74.7197C75.7166 107.114 76.5248 107.635 76.5248 108.277C76.5248 108.92 75.7166 109.441 74.7197 109.441H41.0248C40.0279 109.441 39.2197 108.92 39.2197 108.277Z",
    fill: "url(#paint6_linear_1985_627)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65.0934,
    cy: 155.771,
    r: 3.00847,
    fill: "#3361CF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.822,
    cy: 58.8983,
    rx: 5.41525,
    ry: 4.81356,
    fill: "#E6EAF3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.856,
    cy: 46.2627,
    r: 5.41525,
    fill: "#E6EAF3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 37.839,
    r: 6.61864,
    fill: "#E6EAF3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.153,
    cy: 33.6271,
    r: 7.22034,
    fill: "#E6EAF3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.212,
    cy: 33.0254,
    r: 9.02542,
    fill: "#E6EAF3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 202.882,
    cy: 40.8475,
    r: 10.8305,
    fill: "#E6EAF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 220.632,
    y: 35.733,
    width: 153.432,
    height: 111.314,
    rx: 8.72458,
    fill: "#E6EAF3",
    stroke: "#3361CF",
    strokeWidth: 1.80508
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 273.882,
    y: 147.949,
    width: 46.9322,
    height: 9.62712,
    rx: 4.81356,
    fill: "#3361CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.759 94.0601C301.385 94.0601 301.211 93.786 301.385 93.462C301.385 93.462 302.357 91.4682 302.357 90.1224C302.357 86.409 299.342 83.3934 295.628 83.3934C291.915 83.3934 288.899 86.409 288.899 90.1224C288.899 93.8358 291.915 96.8514 295.628 96.8514C297.223 96.8514 298.968 95.9043 298.968 95.9043C299.292 95.7299 299.566 95.8794 299.566 96.2533V99.0196C299.566 99.3935 299.865 99.6925 300.239 99.6925H303.254C303.628 99.6925 303.927 99.9916 303.927 100.365V103.954C303.927 104.328 303.628 104.627 303.254 104.627H299.666C299.292 104.627 298.993 104.328 298.993 103.954V101.013C298.993 100.64 298.694 100.415 298.345 100.515C298.345 100.515 296.949 100.889 295.603 100.889C289.647 100.889 284.837 96.0788 284.837 90.1224C284.837 84.166 289.647 79.356 295.603 79.356C301.56 79.356 306.37 84.166 306.37 90.1224C306.37 91.3934 305.797 93.4121 305.797 93.4121C305.697 93.761 305.323 94.0601 304.949 94.0601H301.759V94.0601Z",
    fill: "#EE7233"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M303.23 82.4969C305.199 84.4408 306.395 87.1823 306.395 90.1231C306.395 91.3941 305.822 93.4128 305.822 93.4128C305.723 93.7618 305.349 94.0608 304.975 94.0608H301.76C301.386 94.0608 301.212 93.7867 301.386 93.4627C301.386 93.4627 302.358 91.4689 302.358 90.1231C302.358 88.2789 301.61 86.5592 300.364 85.338L303.23 82.4969Z",
    fill: "#3C5BA6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M290.893 85.3373C292.089 84.141 293.809 83.3934 295.628 83.3934C297.423 83.3934 299.142 84.141 300.363 85.3373L303.229 82.4962C301.286 80.5273 298.544 79.356 295.628 79.356C292.687 79.356 289.996 80.5522 288.002 82.5211L290.893 85.3373Z",
    fill: "#3C5BA6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M290.843 94.8334C289.646 93.6122 288.899 91.9424 288.899 90.0982C288.899 88.3038 289.597 86.5841 290.893 85.3131L288.002 82.4969C286.008 84.4907 284.861 87.2072 284.861 90.0982C284.861 93.0639 286.058 95.7805 288.002 97.6995L290.843 94.8334Z",
    fill: "#EE7233"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M243.151 86.8802H237.78V84.9174H250.757V86.8802H245.386V100.62H243.178V86.8802H243.151Z",
    fill: "#444444"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M264.168 93.8029V100.618H262.014V94.021C262.014 91.7038 260.842 90.5588 258.798 90.5588C256.508 90.5588 255.035 91.9219 255.035 94.5117V100.618H252.882V83.9888H255.035V90.4225C255.935 89.2775 257.407 88.6233 259.234 88.6233C262.123 88.6505 264.168 90.2862 264.168 93.8029Z",
    fill: "#444444"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M278.918 95.4108H269.267C269.54 97.4827 271.23 98.873 273.574 98.873C274.965 98.873 276.137 98.4096 277.009 97.4282L278.209 98.8185C277.146 100.073 275.51 100.754 273.52 100.754C269.676 100.754 267.141 98.2187 267.141 94.6748C267.141 91.1581 269.676 88.6227 273.111 88.6227C276.546 88.6227 278.972 91.0763 278.972 94.7293C278.945 94.9474 278.945 95.1927 278.918 95.4108ZM269.267 93.8569H276.9C276.682 91.8668 275.183 90.4493 273.084 90.4493C271.012 90.4493 269.512 91.8396 269.267 93.8569Z",
    fill: "#444444"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M319.835 88.8146V100.701H317.791V98.9013C316.918 100.128 315.446 100.837 313.756 100.837C310.676 100.837 308.658 99.1466 308.658 95.6572V88.8146H310.812V95.4118C310.812 97.729 311.984 98.9013 314.029 98.9013C316.264 98.9013 317.709 97.5109 317.709 94.9484V88.8146H319.835Z",
    fill: "#444444"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M334.611 95.4659H324.988C325.26 97.5377 326.951 98.9281 329.295 98.9281C330.685 98.9281 331.858 98.4646 332.73 97.4832L333.929 98.8735C332.866 100.128 331.231 100.809 329.24 100.809C325.397 100.809 322.861 98.2738 322.861 94.7298C322.861 91.2131 325.397 88.6778 328.832 88.6778C332.266 88.6778 334.693 91.1313 334.693 94.7843C334.665 95.0024 334.638 95.275 334.611 95.4659ZM324.988 93.9392H332.621C332.403 91.9492 330.903 90.5316 328.804 90.5316C326.732 90.5316 325.206 91.9219 324.988 93.9392Z",
    fill: "#444444"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M336.137 99.4465L337.036 97.7563C338.045 98.4651 339.653 98.983 341.207 98.983C343.197 98.983 344.043 98.3833 344.043 97.3746C344.043 94.703 336.546 97.0202 336.546 92.2767C336.546 90.1504 338.454 88.7055 341.507 88.7055C343.061 88.7055 344.806 89.1144 345.842 89.7687L344.915 91.4589C343.852 90.7774 342.652 90.5048 341.48 90.5048C339.599 90.5048 338.672 91.1863 338.672 92.1404C338.672 94.9484 346.196 92.6584 346.196 97.2656C346.196 99.4192 344.233 100.782 341.071 100.782C339.081 100.837 337.118 100.237 336.137 99.4465Z",
    fill: "#444444"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M355.548 99.9903C354.894 100.563 353.912 100.808 352.958 100.808C350.559 100.808 349.196 99.4996 349.196 97.1006V90.5851H347.179V88.8132H349.196V86.2233H351.35V88.8132H354.757V90.5851H351.35V97.0188C351.35 98.3001 352.031 99.0089 353.203 99.0089C353.83 99.0089 354.43 98.8181 354.894 98.4364L355.548 99.9903Z",
    fill: "#444444"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.239,
    cy: 147.949,
    r: 13.839,
    fill: "#E7F6CD",
    stroke: "#99C551",
    strokeWidth: 1.20339
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M324.425 147.949L328.637 152.161L335.255 145.542",
    stroke: "#99C551",
    strokeWidth: 1.20339,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1985_627",
    x1: 62.0841,
    y1: 74.5424,
    x2: 62.0841,
    y2: 123.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3361CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3361CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1985_627",
    x1: 62.0841,
    y1: 74.5424,
    x2: 62.0841,
    y2: 123.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3361CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3361CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1985_627",
    x1: 62.0841,
    y1: 74.5424,
    x2: 62.0841,
    y2: 123.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3361CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3361CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1985_627",
    x1: 62.0841,
    y1: 74.5424,
    x2: 62.0841,
    y2: 123.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3361CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3361CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1985_627",
    x1: 62.0841,
    y1: 74.5424,
    x2: 62.0841,
    y2: 123.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3361CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3361CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1985_627",
    x1: 62.0841,
    y1: 74.5424,
    x2: 62.0841,
    y2: 123.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3361CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3361CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1985_627",
    x1: 62.0841,
    y1: 74.5424,
    x2: 62.0841,
    y2: 123.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3361CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3361CF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDefault);
export default __webpack_public_path__ + "static/media/mobile_default.446246d742c0df3d83cdca7bc9d94a1b.svg";
export { ForwardRef as ReactComponent };